import React, { createContext, useState, useEffect, useContext } from "react";
import { auth, db } from "../firebase/fire";
import { onAuthStateChanged } from "firebase/auth";
import { query, where, getDocs, collection, doc, getDoc, limit } from "firebase/firestore";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAddingCoach, setIsAddingCoach] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      setLoading(true);
      
      if (authUser && !isAddingCoach) {
        setUser(authUser);
        try {
          const adminQuery = query(
            collection(db, "admin"),
            where("uid", "==", authUser.uid),
            limit(1)
          );

          const [adminSnapshot, memberDoc, coachDoc, secAdminDoc] = await Promise.all([
            getDocs(adminQuery),
            getDoc(doc(db, "members", authUser.uid)),
            getDoc(doc(db, "coaches", authUser.uid)),
            getDoc(doc(db, "secondaryAdmin", authUser.uid))
          ]);

          if (!adminSnapshot.empty) {
            setUserRole("admin");
          } else if (memberDoc.exists()) {
            setUserRole("member");
          } else if (coachDoc.exists()) {
            setUserRole("coach");
          } else if (secAdminDoc.exists()) {
            setUserRole("admin");
          } else {
            console.error("No user data found in admin, members, or coaches collection.");
            setUserRole(null);
          }
        } catch (error) {
          console.error("Error checking user role:", error);
          setUserRole(null);
        }
      } else if (!isAddingCoach) {
        setUser(null);
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [isAddingCoach]);

  const setAddingCoach = (value) => {
    setIsAddingCoach(value);
  };
  const value = {
    user,
    userRole,
    loading,
    setAddingCoach: setIsAddingCoach,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};